import Image from "next/image";
import Head from "next/head";
import styles from "./mains-crash-course.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import youtube_thumnail_1 from "../../assets/images/home/youtube/CSE-Mains-Program- Youtube-Thumbnail.jpg";
import redrightarrow from "../../assets/images/contact/redrightarrow.png";
// import Interest from "../../components/might-be-interest";
import crashcourse from "../../assets/images/upsc/upsc-mains-skillup-web-banner.jpg";
import Mobcrashcourse from "../../assets/images/upsc/upsc-mains-skillup-mob-banner.jpg";
import Link from "next/link";
import check from "../../assets/images/upsc/check.png";
import { useEffect, useState } from 'react';

const Mains_Skillup_Programme = () => {
    const [play, setPlay] = useState(false);
    const [play1, setPlay1] = useState(false);
   const feestructure3 =[

        {center: "Regular(Hybrid)",  start: (<><div>30th June 2025</div> <div>5:30 pm to 8:00 pm</div></>),
            fee: (<><div>₹20,000</div></>),
            cont3:(<Link href="https://www.shankariasacademy.com/pdf/upsc-mains-skillup-2025/Upsc-Mains-Skillup-2025-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}> Click here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}>
                Pay Now
                </button>
            </a>)
        },
      ]
    return (  
        <>
  
        <Head>
            <meta charset="UTF-8" />
           
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index, follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Best UPSC Mains Mentorship Program 2025 in India</title>
            <meta name="title" content="Best UPSC Mains Mentorship Program 2025 in India" />
            <meta name="keywords" content="UPSC Mains Crash Course ,UPSC Crash Course for Mains ,UPSC GS Mains Crash Course ,Mains GS Crash Course,Online UPSC Mains Crash Course, UPSC Mains Crash Course Syllabus,UPSC Mains Crash Course Fees, UPSC Mains Crash Course Admission , UPSC Mains Crash Course Details ,Best Crash Course for UPSC Mains  " />
            <meta name="description" content="Join Shankar IAS Academy’s UPSC Mains Mentorship Program 2025–2026 in India. Boost your mains preparation with personalized Skillup mentorship." />
            <link rel="canonical" href="https://www.shankariasacademy.com/upsc-mains-mentorship-programme/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Best UPSC Mains Mentorship Program 2025 in India" />
            <meta property="og:description" content="Join Shankar IAS Academy’s UPSC Mains Mentorship Program 2025–2026 in India. Boost your mains preparation with personalized Skillup mentorship." />
            <meta property="og:url" content="https://www.shankariasacademy.com/upsc-mains-mentorship-programme/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

        <Navbar title="upsc" />
        
        <div className="container">

            <div className="row">
            <div className="col pt-3 pt-md-3   pb-md-2">
                <h1 className={`${styles.pagemaintitle}`}>UPSC Mains Mentorship Programme 2025 - 2026</h1>
            </div>
            </div>

           <div className="row d-none d-md-block">
            <div className="col mb-3">
              <Image
                src={crashcourse}
                alt="UPSC Mains Crash Course 2024"
                title="UPSC Mains Crash Course 2024"
                className="img-fluid w-100"
              />
            </div> 
          </div>

        <div className="row d-block d-md-none">
          <div className="col mb-3">
              <Image
                src={Mobcrashcourse}
                alt="UPSC Mains Crash Course 2024"
                title="UPSC Mains Crash Course 2024"
                className="img-fluid w-100"
              />
            </div>
          </div> 

        </div>
        
  

        {/* table */}
            

    <section  id="courseandfees" style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
        <div className="container pt-xl-4" >
            <div className="row">
                    <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Batch</div>
                    <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Starts on</div>
                    <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Fee</div>
                    <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Brochure</div>
                    <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Payment</div>
                    <hr/>
            </div>
                    
            {feestructure3.map((item,index)=>(
                <div className={`${styles.facultyborder3} row`}>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-0`}>{item.center}</div>
                     
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-0`}>{item.start}</div>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Fee</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.fee}</div>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Brochure</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.cont3}</div>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Payment</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-0`}>
                              {item.pay}
                            </div>
                            <hr/>
                </div>
                    ))} 
                </div>
	</section> 

<div className="container-fluid "
                style={{background: "transparent linear-gradient(180deg, #F4F6F8 0%, #F4F6F8 75%, #F4F6F800 100%) 0% 0% no-repeat padding-box", opacity: "1",}}>
                  <div className="container">                   
                    <div className="row ">
                        <div className="col-12 col-xl-6 col-lg-8 col-md-10 mx-auto text-start mb-5">
                       
                           
                            </div>
                            <h3 className={`${styles.sectionsubtitle} pt-2`}>What is ‘Mains SkillUp’ Program? </h3>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />SkillUp is a comprehensive and targeted UPSC Mains preparation program by Shankar IAS Academy, designed to address one of the most critical - yet often overlooked - needs of UPSC aspirants, being truly ready for the UPSC Mains examination. </p>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />In the typical journey of UPSC preparation, aspirants tend to focus entirely on Prelims for an entire year. Those who clear it often find themselves writing their first Mains answer only after Prelims, without adequate mains specific content in their hands. This last-minute effort fails to secure a Mains score significantly higher than the mains cutoff which is what secures aspirants the service of their preference. Meanwhile, aspirants who don’t clear Prelims usually repeat the same cycle - without improving their UPSC Mains readiness. </p>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />To break this pattern and equip aspirants with consistent UPSC Mains preparation, Shankar IAS Academy introduces the unique LCT Strategy as a part of the ‘Skillup’ program.</p>
                            
                             
                            <div className="container py-5">
                              <div className="row g-4">
                                 <div className="col-md-6 pt-4 mt-3">
                                    <h3 className={`${styles.sectionsubtitle} text-center mb-3`}>What is the LCT Strategy?</h3>
                                    <h4 className={`${styles.subtitle} text-center mb-5`}>LCT = Lecture + Curation + Test</h4>
                                </div> 
                                 <div className="col-12 col-lg-6 my-md-3 px-xl-3">
                                    {
                                      play ?
                                        (<iframe src={"https://www.youtube.com/embed/lwNrVhVQ588?si=gHP1Q9v_OIvvb8FA"} className="w-100 h-100  mb-md-3" id="homeyoutube" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ borderWidth: '0' }}></iframe>)
                                        :
                                        (<Image src={youtube_thumnail_1} style={{ cursor: 'pointer' }} onClick={() => setPlay(true)} className="img-fluid h-100 w-100  mb-md-3"
                                          id="homeyoutube" alt="youtube thumbnail"></Image>)
                                    }
                                    {/* <div className="d-none d-md-block"><Link
                                      href="https://www.iasparliament.com/UPSC-IAS-daily-current-videos"
                                      target="_blank"
                                      className={`${styles.curntbutton}  ps-3   float-end`}
                                    >
                                      All Current Affairs  <Image src={redrightarrow}  alt="arrow icon" title="Link" />
                                    </Link></div> */}
                                  </div>
                             </div>
                              <div className="row g-4">
                                {/* LECTURE CARD */}
                                <div className="col-md-4">
                                  <div className="p-4 shadow rounded-4 h-100 bg-white">
                                    <h4 className={`${styles.subtitle} mb-3`}>📘 Lecture</h4>
                                    <ul className="list-unstyled">
                                      <li className={`${styles.aboutparagraph1} mb-2`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>75 sessions covering core and difficult GS topics 
                                      </li>
                                      <li className={`${styles.aboutparagraph1} mb-2`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>Conducted every Monday, Wednesday, and Friday                                      </li>
                                      <li className={`${styles.aboutparagraph1} mb-2`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>Each session is 2.5 hours, starting from June 30, 2025 
                                      </li>
                                      <li className={`${styles.aboutparagraph1} mb-2`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>Lectures focus on ‘the most difficult topics’ in Mains syllabus sheet & often overlooked areas due to the complexity & lack of adequate materials such as: 
                                        <ul className="mt-2 ps-4">
                                          <li>Conceptual & philosophical depth in understanding of Polity & Governance based topics </li>
                                          <li>New areas specific to Mains – World History & Post Independence Consolidation </li>
                                          <li>Integration of Ethics concepts in the case studies</li>
                                          <li>GS Paper 3 - Factual nuances & ways of tackling challenging qns </li>
                                        </ul>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                {/* CURATION CARD */}
                                <div className="col-md-4">
                                  <div className="p-4 shadow rounded-4 h-100 bg-white">
                                    <h4 className={`${styles.subtitle} mb-3`}>✅ Curation</h4>
                                    <ul className="list-unstyled">
                                      <li className={`${styles.aboutparagraph1} mb-2`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>75 curation sessions on Tuesday, Thursday, and Saturday 
                                      </li>
                                      <li className={`${styles.aboutparagraph1} mb-2`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>Aspirants work on assignments based on lecture topics 
                                      </li>
                                      <li className={`${styles.aboutparagraph1} mb-2`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>Reference materials will be shared for deeper insights 
                                      </li>
                                      <li className={`${styles.aboutparagraph1} mb-2`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>Helps aspirants:
                                        <ul className="mt-2 ps-4">
                                          <li>Understand the Mains mindset</li>
                                          <li>Curate informed opinions</li>
                                          <li>Address the demand of the question effectively </li>
                                        </ul>
                                      </li>
                                      <li className={`${styles.aboutparagraph1}`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>By the end of 6 months, students will have compiled around 150+ pages of their own notes per GS paper — fully personalized, relevant, and usable
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                {/* TEST CARD */}
                                <div className="col-md-4">
                                  <div className="p-4 shadow rounded-4 h-100 bg-white">
                                    <h4 className={`${styles.subtitle} mb-3`}>📝 Test</h4>
                                    <ul className="list-unstyled">
                                      <li className={`${styles.aboutparagraph1} mb-2`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>Regular tests before the beginning of every session to assess content quality and depth prepared in the preceding two days 
                                      </li>
                                      <li className={`${styles.aboutparagraph1} mb-2`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>Rather than faculty evaluations, a framework-based self-evaluation model is used 
                                      </li>
                                      <li className={`${styles.aboutparagraph1} mb-2`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>After each test:
                                        <ul className="mt-2 ps-4">
                                          <li>A model answer framework is provided </li>
                                          <li>Aspirants compare their own answers, class discussions, and personal notes </li>
                                        </ul>
                                      </li>
                                      <li className={`${styles.aboutparagraph1}`}>
                                        <span className={`${styles.dot} pe-2`}>*</span>This sharpens self-awareness, improves retention, and deepens understanding 
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <h3 className={`${styles.sectionsubtitle} pt-2`}>Expected Outcome </h3>
                            <p className={`${styles.tablepara1}`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />By the end of the program in December 2025, aspirants will have mastered: </p>
                            <ul className={`${styles.tableparagp}`}>
                                <li>What to read </li>
                                <li>How to take effective Mains notes</li>
                                <li>How to frame quality answers </li>
                                <li>And most importantly, <br/>how to continue this process independently</li>
                            </ul>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />The ultimate aim of Skill Up is to build the skillset, mindset, and habits needed to crack the Mains 2026 — not just once, but every time. </p>
                            
                      </div>

                  </div>
               </div>

{/* Mobile View */}

{/* <section className=" " style={{background: "" , opacity: "1"}}>
    <div className="container mt-2 mb-5">
        <div className="col-12 col-xl-12 ">   
        <div className="row">
     
        <div class=" col-12 col-xl-12 d-block d-md-none" style={{backgroundColor:"#f4f6f8"}}>
          <div class="py-2" style={{backgroundColor: "#001e62"}}><h2 className={`${styles.tabletitle}`}>UPSC Mains Crash Course 2024</h2></div>
                    <div class="row border-bottom">
								<div class={`${styles.tableheading} col-12 col-md-3 d-none d-md-block `}>Batch</div>
								<div class={`${styles.tableheading} col-12 col-md-3 d-none d-md-block`}>Starts On</div>
								<div class={`${styles.tableheading} col-12 col-md-3 d-none d-md-block`}>Fees</div>
                                <div class={`${styles.tableheading} col-12 col-md-3 d-none d-md-block`}>Admission</div>				
					</div>
                 
                <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Batch</div>
                    <div class="col-6 pt-3 col-md-3"><b>Regular(Hybrid)</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Starts On</div>
                    <div class="col-6 pt-3 col-md-3">25th June 2024 <br/>2:30 pm - 7:30 pm</div>
                    <div class="col-6 pt-3 d-block d-md-none">Fees</div>
                    <div class="col-6 pt-3 col-md-3"><b>₹36,000</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
               
                                  
	      </div>
        </div>
        </div>
        </div>
</section> */}



               


       
        <Footer />                      
        </>
    )
}
export default Mains_Skillup_Programme;
